import React, {ChangeEvent, useEffect} from "react";
import {IDropDownItemViewModel} from "../../models/item-model/drop-down-item-view-model.interface";
import {observer} from "mobx-react";
import {IDropDownListViewModel} from "../../models/list-model/drop-down-list-view-model.interface";
import {InputBox} from "./input.box";


interface DropDownInputComponentProps<TItem extends IDropDownItemViewModel> {
    listViewModel: IDropDownListViewModel<TItem>
    captureInputRef: (element: HTMLInputElement) => void;
}

export const DropDownInputComponent = observer(<TItem extends IDropDownItemViewModel>(props: DropDownInputComponentProps<TItem>) => {
    const inputRef = React.createRef<HTMLInputElement>();

    useEffect(() => {
        if(inputRef.current) {
            props.captureInputRef(inputRef.current)
        }
    })

    const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        props.listViewModel.currentInputText = event.target.value ?? "";
    }

    return <InputBox ref={inputRef}
                     autoComplete="off"
                     value={props.listViewModel.currentInputText}
                     placeholder={props.listViewModel.inputPlaceholder}
                     onChange={onInputChange} />
});
